import { render, staticRenderFns } from "./home_none.vue?vue&type=template&id=1452726e&scoped=true"
import script from "./home_none.vue?vue&type=script&lang=js"
export * from "./home_none.vue?vue&type=script&lang=js"
import style0 from "./home_none.vue?vue&type=style&index=0&id=1452726e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1452726e",
  null
  
)

export default component.exports